export default {
  black: '#000',
  white: '#fff',
  'coolGray-50': '#f9fafb',
  'coolGray-100': '#f3f4f6',
  'coolGray-200': '#e5e7eb',
  'coolGray-300': '#d1d5db',
  'coolGray-400': '#9ca3af',
  'coolGray-500': '#6b7280',
  'coolGray-600': '#4b5563',
  'coolGray-700': '#374151',
  'coolGray-800': '#1f2937',
  'coolGray-900': '#111827',
  'red-50': '#fef2f2',
  'red-100': '#fee2e2',
  'red-200': '#fecaca',
  'red-300': '#fca5a5',
  'red-400': '#f87171',
  'red-500': '#ef4444',
  'red-600': '#dc2626',
  'red-700': '#b91c1c',
  'red-800': '#991b1b',
  'red-900': '#7f1d1d',
  'yellow-50': '#fefce8',
  'yellow-100': '#fef9c3',
  'yellow-200': '#fef08a',
  'yellow-300': '#fde047',
  'yellow-400': '#facc15',
  'yellow-500': '#eab308',
  'yellow-600': '#ca8a04',
  'yellow-700': '#a16207',
  'yellow-800': '#854d0e',
  'yellow-900': '#713f12',
  'amber-50': '#fffbeb',
  'amber-100': '#fef3c7',
  'amber-200': '#fde68a',
  'amber-300': '#fcd34d',
  'amber-400': '#fbbf24',
  'amber-500': '#f59e0b',
  'amber-600': '#d97706',
  'amber-700': '#b45309',
  'amber-800': '#92400e',
  'amber-900': '#78350f',
  'orange-50': '#fff7ed',
  'orange-100': '#ffedd5',
  'orange-200': '#fed7aa',
  'orange-300': '#fdba74',
  'orange-400': '#fb923c',
  'orange-500': '#f97316',
  'orange-600': '#ea580c',
  'orange-700': '#c2410c',
  'orange-800': '#9a3412',
  'orange-900': '#7c2d12',
  'teal-50': '#effffc',
  'teal-100': '#c2f4ed',
  'teal-200': '#bbfaee',
  'teal-300': '#9af7e6',
  'teal-400': '#78f5de',
  'teal-500': '#71e5d0',
  'teal-600': '#6ad8c4',
  'teal-700': '#64ccb9',
  'teal-800': '#5fc0af',
  'teal-900': '#4f9e90',
  'teal-1000': '#477169',
  'blue-25': '#f1f1f7',
  'blue-50': '#e8e7f1',
  'blue-100': '#dddced',
  'blue-200': '#c7c3e4',
  'blue-300': '#b2abdb',
  'blue-400': '#9b92d2',
  'blue-500': '#8479c7',
  'blue-600': '#6f62be',
  'blue-700': '#594ab6',
  'blue-800': '#4331ac',
  'blue-900': '#17009a',
  'blue-1000': '#10006c',
  'indigo-50': '#eef2ff',
  'indigo-100': '#e0e8ff',
  'indigo-200': '#c8d3fe',
  'indigo-300': '#a6b4fc',
  'indigo-400': '#828df8',
  'indigo-500': '#6467f2',
  'indigo-600': '#5048e5',
  'indigo-700': '#463acb',
  'indigo-800': '#372fa2',
  'indigo-900': '#312e7f',
  'purple-50': '#faf5ff',
  'purple-100': '#f3e8ff',
  'purple-200': '#e9d5ff',
  'purple-300': '#d8b4fe',
  'purple-400': '#c084fc',
  'purple-500': '#a855f7',
  'purple-600': '#9333ea',
  'purple-700': '#7e22ce',
  'purple-800': '#6b21a8',
  'purple-900': '#581c87',
  'pink-50': '#f2e8ee',
  'pink-100': '#f1dfe7',
  'pink-200': '#edc9d7',
  'pink-300': '#ecb3c9',
  'pink-400': '#e99db9',
  'pink-500': '#e587a8',
  'pink-600': '#e37399',
  'pink-700': '#e15e8a',
  'pink-800': '#df477b',
  'pink-900': '#d91c5c',
  'pink-1000': '#b7184e',
};
